import * as types from './types'
import jwtDecode from 'jwt-decode'
export default {
  [types.SET_PASSTHROUGH](state, passthrough) {
    state.passthrough = passthrough
  },
  [types.SET_USER](state, token) {
    state.loggedUser.username = jwtDecode(token).prn
    state.loggedUser.role = 'user'
    localStorage.setItem('token', token)
    state.token = token
    if (localStorage.getItem('userProfile') !== undefined && localStorage.getItem('userProfile') !== null) {
      state.userProfile = JSON.parse(localStorage.getItem('userProfile'))
      state.loggedUser.role = state.userProfile.Role
    }
  },
  [types.SET_USER_INFO](state, data) {
    if (data.length > 0) {
      state.userProfile = data[0]
      localStorage.setItem('userProfile', JSON.stringify(data[0]))
      state.loggedUser.role = state.userProfile.Role
    }
  },
  [types.LOGOUT](state) {
    state.token = ''
    state.role = ''
    state.roles = null
    state.userProfile = null
    state.loggedUser = { username: null, role: null }
    localStorage.removeItem('token')
    localStorage.removeItem('roles')
    localStorage.removeItem('role')
    localStorage.removeItem('userProfile')
  },
  [types.SET_ROLES](state, profile) {
    state.primaryRole = ''
    if (profile && profile.Roles && profile.Roles.length) {
      var roles = profile.Roles.map(r => r.Name)
      state.roles = roles
      localStorage.setItem('roles', JSON.stringify(roles))
      if (roles.length > 0) {
        state.primaryRole = roles[0]
      }
      localStorage.setItem('role', JSON.stringify(state.primaryRole))
      console.log('Saving Roles', { roles: state.roles, role: state.primaryRole })
    }
  },
  [types.SET_SOLUTION](state, solution) {
    state.solution = solution
    state.solutions.forEach(element => {
      if (parseInt(element.value) === parseInt(solution)) {
        localStorage.setItem('solution', solution)
        state.channelType = element.type
        localStorage.setItem('channelType', element.type)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js